import { render, staticRenderFns } from "./InpatientEMRHeader.vue?vue&type=template&id=54d90bdc&scoped=true"
import script from "./InpatientEMRHeader.vue?vue&type=script&lang=js"
export * from "./InpatientEMRHeader.vue?vue&type=script&lang=js"
import style0 from "./InpatientEMRHeader.vue?vue&type=style&index=0&id=54d90bdc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54d90bdc",
  null
  
)

export default component.exports